export const mutations = {

    initialiseStore(state) {
        // Check if the ID exists
        if (localStorage.getItem('store')) {
            // Replace the state object with the stored item
            this.replaceState(
                Object.assign(state, JSON.parse(localStorage.getItem('store')))
            );
        }
    },

    setAuthToken(state, token) {
        if (token) {
            localStorage.setItem('authToken', token)
        }
    },

    setProspectSession(state, prospectId) {
        // Store the prospect id in session storage so that prospect will be available even after page refresh
        if(prospectId) {
            sessionStorage.setItem('prospectId', prospectId);
        } else {
            this.commit('clearProspectSession');
        }
    },
    clearProspectSession() {
        sessionStorage.removeItem('prospectId');
    }
}
